var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { "data-qa": "price_home" } }, [
    _c(
      "div",
      {
        staticClass: "text-h6 text--text mb-1",
        attrs: { "data-qa": "price_home_num" },
      },
      [_vm._v("\n    " + _vm._s(_setup.formattedPrice) + "\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }